/**
 * How a runner reads on screen. A goal line is short — "Over 2.5 Goals" is "O2.5",
 * "Finland Under 2 5 Goals" is "Finland U2.5" — so it fits beside its prices.
 *
 * Display only: the engine still matches the stored names ("Over…", "Under…").
 */
export function displayRunner(name: string): string {
  return name.replace(/\b(Over|Under) (\d+)[ .](\d)(?: Goals)?\b/g, (_, side: string, whole: string, frac: string) =>
    `${side[0]}${whole}.${frac}`,
  )
}

const OVER_UNDER = /^(Over|Under|O|U) ?(\d+)[ .](\d)(?: Goals)?$/

/**
 * How a selection reads in a list of bets — a slip, P&L, an accumulator's legs — where
 * no market heading sits above it. A goal line says what it is on its own, so its market
 * is dropped: "Over 2.5 Goals" in Over/Under 2.5 Goals reads "FT O2.5 Goals", in First
 * Half Over/Under 0.5 "1H O0.5 Goals", in Portugal Over/Under 1.5 "Portugal FT O1.5
 * Goals". Anything else keeps its market, which it needs ("Portugal" alone could be match
 * odds, draw no bet or half time). Takes the stored name or the short one alike.
 */
export function betSelection(runner: string, market: string): { label: string; market: string | null } {
  const m = OVER_UNDER.exec(runner.trim())
  if (m) {
    const ou = `${m[1]![0]}${m[2]}.${m[3]}`
    if (/^Over\/Under [\d.]+ Goals$/.test(market)) return { label: `FT ${ou} Goals`, market: null }
    if (/^First Half Over\/Under [\d.]+$/.test(market)) return { label: `1H ${ou} Goals`, market: null }
    const team = /^(.+) Over\/Under [\d.]+$/.exec(market)
    if (team) return { label: `${team[1]} FT ${ou} Goals`, market: null }
    const other = /^Over\/Under [\d.]+ (Cards|Corners)$/.exec(market)
    if (other) return { label: `FT ${ou} ${other[1]}`, market: null }
  }
  return { label: displayRunner(runner), market }
}
